<script>
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric"; 
export default {
    mixins: [Api, Sabit],
    props:["Update","GirisId"],
    data() {
        return {
            Page: {
                    PageNumber: "1",
                    PageSize: "9999",
                    PageDataSize: "1", 
             },
             TableData: [],
              
        }
    }, 
    methods:{  
     
    Get(){ 
     
        let Filter="&GirisId="+this.GirisId;
        this.ActionsFilterGet({Service:"StrRisklerGirislerCevap",Page:this.Page,Filter:Filter}).then(res => {
    
        this.TableData = res.Data 
        this.Page.PageDataSize = res.TotalCount; 

         }); 
         
    },

    veri_gonder(data, islem) {
      this.$emit("DataUpdate", data);
      this.$emit("AddEdit", islem);
    },

    },   
    watch: {
        Update() {
             this.Get();
        }
    }
 };
</script>
<template>
  <div class="table-responsive">

                        <table class="table table-striped table-bordered mb-0">
                            <thead>
                              <tr>
                                <th scope="col">{{$t('StrRisklerGirislerCevap.AltTable.BirimAdi')}}</th>
                                <th scope="col">{{$t('StrRisklerGirislerCevap.AltTable.Cevap')}}</th>               
                                <th scope="col">{{$t('StrRisklerGirislerCevap.AltTable.BaslamaTarihi')}}</th>
                                <th scope="col">{{$t('StrRisklerGirislerCevap.AltTable.BitisTarihi')}}</th>  
                                <th scope="col">{{$t('StrRisklerGirislerCevap.AltTable.Tamamlanma')}}</th>  
                                <th scope="col">{{$t('StrRisklerGirislerCevap.AltTable.Islem')}}</th>  
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="TableDataVerileri in TableData"  :key="TableDataVerileri.Id">
                                <td>{{ TableDataVerileri.BirimAdi }}</td>
                                <td>{{ TableDataVerileri.Cevap }}</td> 
                                <td>{{ TableDataVerileri.BaslamaTarihi | formatDateTable}}</td> 
                                <td>{{ TableDataVerileri.BitisTarihi | formatDateTable }}</td> 
                                <td>
                                  <i v-if="TableDataVerileri.Tamamlanma==1" class="fas fas fa-check"></i>
                                  <i v-if="TableDataVerileri.Tamamlanma==0" class="fas fas fa-times"></i>
                                </td> 
                                <td style="width: 80px; text-align: center; vertical-align: middle;">
                                <b-button-group>
                                  
                                  <b-button variant="primary" v-b-modal.StrRisklerGirislerCevap 
                                    @click="veri_gonder(TableDataVerileri, 'Edit')">
                                    <i class="fas fa-pencil-alt"></i>
                                  </b-button>                    
                         <b-button variant="danger" @click="Delete('StrRisklerGirislerCevap', TableDataVerileri.Id)"><i class="fas fa-trash-alt"></i></b-button>
                      </b-button-group>
                    </td>
                              </tr> 
                            </tbody>
                          </table>

    </div>
</template>